import { Component, OnInit, ViewChild, ElementRef, Input } from '@angular/core';
import { NgbModal, ModalDismissReasons, NgbModalRef } from '@ng-bootstrap/ng-bootstrap';
import { FormControl, AbstractControl, Validators, FormArray, FormBuilder, FormGroup, } from '@angular/forms';
import { OrganizationService } from '../../services/organizations/organization.service';
@Component({
  selector: 'app-social-popup',
  templateUrl: './social-popup.component.html',
  styleUrls: ['./social-popup.component.css']
})
export class SocialPopupComponent implements OnInit {
  @ViewChild('contentSocial') modal: ElementRef;
  @Input() socialMediaId: string;
  @Input() parentId: string;
  @Input() parentType: string;
  @Input() action: string;
  social: FormGroup;
  modalRef: NgbModalRef;
  twitError;
  linkedError;
  fbError;
  googleError;
  instaError;
  constructor(
    private modalService: NgbModal,
    private formBuilder: FormBuilder,
    private orgService: OrganizationService
  ) { }

  ngOnInit() {
    this.resetForm();
  }

  resetForm() {
    this.social = this.formBuilder.group({
      'twitterurl': [null],
      'linkedinurl': [null],
      'facebookurl': [null],
      'googleplusurl': [null],
      'instagramurl': [null],
    });
  }

  showModal() {
    this.modalRef = this.modalService.open(this.modal, { windowClass: 'social-modal' })
    this.modalRef.result.then((data) => {
     
      // this.resetForm();
    }, (reason) => {
     
      // this.resetForm();
    });
  }
  updateSocial() {
    let formData = {
      'social_media_id': this.socialMediaId,
      'linkedin_url': this.validWebsite(this.social.controls['linkedinurl'].value),
      'facebook_url': this.validWebsite(this.social.controls['facebookurl'].value),
      'instagram_url': this.validWebsite(this.social.controls['instagramurl'].value),
      'twitter_url': this.validWebsite(this.social.controls['twitterurl'].value),
      'googleplus_url': this.validWebsite(this.social.controls['googleplusurl'].value),
      'business_id': this.parentId,
      'business_type': this.parentType
    };
    this.orgService.updateSocialMedia(formData).subscribe(res => {
     
      this.modalRef.close();
    });
  }
  validWebsite(url) {
    const pattern = /^(http:\/\/www\.|https:\/\/www\.|http:\/\/|https:\/\/)[a-z0-9]+([\-\.]{1}[a-z0-9]+)*\.[a-z]{2,5}(:[0-9]{1,5})?(\/.*)?$/;
    if (url === 'http://' || url === 'http://null') {
      return '';
    } else if (url == null) {
      return url;
    } else if (url && !pattern.test(url)) {
      return 'http://' + url;
    } else {
      return url;
    }
  }
  validUrl(event) {
    let value = event.target.value;
    this.resetError();
    const pattern = /^(?:http(s)?:\/\/)?[\w.-]+(?:\.[\w\.-]+)+[\w\-\._~:/?#[\]@!\$&'\(\)\*\+,;=.]+$/;
    if (value != "" && !pattern.test(value)) {
      if (event.target.id == 'twitterurl') {
        this.twitError = 'Please Enter Valid Twitter Url';
      } else if (event.target.id == 'linkedinurl') {
        this.linkedError = 'Please Enter Valid Linked in Url';
      }
      else if (event.target.id == 'facebookurl') {
        this.fbError = 'Please Enter Valid Facebook Url';
      }
      else if (event.target.id == 'googleplusurl') {
        this.googleError = 'Please Enter Valid Google Plus Url';
      }
      else if (event.target.id == 'instagramurl') {
        this.instaError = 'Please Enter Valid Instagram Url';
      }
      this.social.controls[event.target.id].setValue('');
    }
  }
  resetError() {
    this.twitError = '';
    this.linkedError = '';
    this.fbError = '';
    this.googleError = '';
    this.instaError = '';
  }
}



// WEBPACK FOOTER //
// ./src/app/shared/modal-popup/social-popup/social-popup.component.ts